module.exports = __webpack_public_path__ + "static/media/cptm_doc4.f045dee2.JPG";